import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { usePost } from "../../../api-client/usePost";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { useNullableDealerAccountInfo } from "../../../stores/hooks/useNullableDealerAccountInfo";
import { useSetInfoToast } from "../../../stores/hooks/useSetInfoToast";
import { Button, PrimaryButton } from "../../../ui/Button/Button";

export const Footer: FunctionComponent<{
  hide: VoidFunction;
  packageToDelete?: PackagePartItem;
  reload(): Promise<void>;
}> = ({ hide, packageToDelete, reload }) => {
  const { t } = useTranslation();
  const dealer = useNullableDealerAccountInfo();
  const setInfoToast = useSetInfoToast();
  const [loading, setLoading] = useState(false);

  const { send: deletePackage } = usePost(
    "/retailSiteWebService/parts/partPackage/deletePartPackageByPartId.php"
  );

  return (
    <footer className="new-package-dialog__footer">
      <Button aria-label="close" onClick={hide}>
        {t("packageEditor.close")}
      </Button>
      <PrimaryButton
        onClick={async (): Promise<void> => {
          setLoading(true);
          try {
            await deletePackage({
              dealerId: dealer?.dealerId || "",
              partId: packageToDelete?.partDetails.primaryPart.itemId || "",
            });
            await reload();
            hide();
            setInfoToast({ message: "packageEditor.packageDeleted" });
          } finally {
            setLoading(false);
          }
        }}
        aria-label="save"
        busy={loading}
      >
        {t("packageEditor.deletePackage")}
      </PrimaryButton>
    </footer>
  );
};
